import {
    GET_TICKETS,
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAILED,

    SUBMIT_TICKET_FORM,
    SUBMIT_TICKET_FORM_SUCCESS,
    SUBMIT_TICKET_FORM_FAILED,

    DELETE_TICKET,
    DELETE_TICKET_SUCCESS,
    DELETE_TICKET_FAILED,

    GET_CURRENT_TICKET,
    GET_CURRENT_TICKET_SUCCESS,
    GET_CURRENT_TICKET_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    tickets: [],
    submittingForm: false,
    error: null,
    deleting: false,
    currentTicket: null
};

const CountryReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TICKETS:
            return { ...state, loading: true };
        case GET_TICKETS_SUCCESS: 
            return { ...state, tickets: action.payload.data, total: action.payload.total, currentTicket: null, loading: false, error: null };
        case GET_TICKETS_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_TICKET_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_TICKET_FORM_SUCCESS:
            const alreadyExists = state.tickets.find((item) => item.id === action.payload.id);
            let tickets;
            let total = state.total;
            if (!alreadyExists) {
                tickets = [action.payload, ...state.tickets];
                total += 1;
            } else {
                tickets = state.tickets.map((item) => {
                if (item.id === action.payload.id) {
                  return action.payload;
                }
                return item;
              });
            }
            return { ...state, total,  tickets, submittingForm: false };
        case SUBMIT_TICKET_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_TICKET:
            return { ...state, error: null, deleting: true };
        case DELETE_TICKET_SUCCESS:
            return { ...state, total: state.total - 1, tickets: state.tickets.filter(item => item.id !== action.payload) , deleting: false };
        case DELETE_TICKET_FAILED:
            return { ...state, error: action.payload, deleting: false };
        
        case GET_CURRENT_TICKET:
            return { ...state, loading: true };
        case GET_CURRENT_TICKET_SUCCESS:
            return { ...state, currentTicket: action.payload, loading: false, error: null };
        case GET_CURRENT_TICKET_FAILED:
            return { ...state, error: action.payload, loading: false };
    
        
        default: return { ...state };
    }
}

export default CountryReducer;